import morningMobile from '../../../../../assets/images/sign-up-banner/morning-mobile.png';
import morningTablet from '../../../../../assets/images/sign-up-banner/morning-tablet.png';
import morningDesktop from '../../../../../assets/images/sign-up-banner/morning.png';
import afternoonMobile from '../../../../../assets/images/sign-up-banner/afternoon-mobile.png';
import afternoonTablet from '../../../../../assets/images/sign-up-banner/afternoon-tablet.png';
import afternoon from '../../../../../assets/images/sign-up-banner/afternoon.png';
import eveningMobile from '../../../../../assets/images/sign-up-banner/evening-mobile.png';
import eveningTablet from '../../../../../assets/images/sign-up-banner/evening-tablet.png';
import evening from '../../../../../assets/images/sign-up-banner/evening.png';

export function getDayPeriod(date: Date = new Date()): DayPeriod {
  const hour = date.getHours();
  if (hour >= 5 && hour < 12) return 'morning';
  if (hour >= 12 && hour < 18) return 'afternoon';
  return 'evening';
}

export type DayPeriod = 'morning' | 'afternoon' | 'evening';

const images = {
  morning: {
    mobile: morningMobile,
    tablet: morningTablet,
    desktop: morningDesktop,
  },
  afternoon: {
    mobile: afternoonMobile,
    tablet: afternoonTablet,
    desktop: afternoon,
  },
  evening: {
    mobile: eveningMobile,
    tablet: eveningTablet,
    desktop: evening,
  },
};

type ResponsiveImageSet = {
  mobile: string;
  tablet: string;
  desktop: string;
};

export function getResponsiveImages(period: DayPeriod): ResponsiveImageSet {
  return images[period];
}

function getTimeBasedImage(
  date: Date = new Date(),
  category: 'mobile' | 'tablet' | 'desktop' = 'desktop',
): string {
  const period = getDayPeriod(date);
  const responsive = getResponsiveImages(period);
  return responsive[category];
}
export const timeBasedImage = (category: 'mobile' | 'tablet' | 'desktop' = 'desktop') => getTimeBasedImage(undefined, category);
